export { getLazyModal } from './modal-map'
export { ModalTypes } from './modal-types'
